module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Cooking/Ladle-73e6d3f91c1eba2afba17c5ad61dfa233ab4a5515cb118f433979ee830f3664f.svg";